import {
  Bell,
  BookmarksSimple,
  Crown,
  Gear,
  Heart,
} from "@phosphor-icons/react/dist/ssr";

export const accountMenu = [
  {
    name: "Subscription",
    icon: <Crown weight='fill' className='flex-shrink-0 size-5' />,
    color: "from-yellow-400 to-orange-600",
    info: undefined,
    url: "/account/plan",
  },
  {
    name: "Notifications",
    icon: <Bell weight='fill' className='flex-shrink-0 size-5' />,
    color: "from-teal-400 to-teal-600",
    info: 48,
    url: "/account/notifications",
  },
  {
    category: "Content",
    children: [
      {
        name: "Preferences",
        icon: <Gear weight='fill' className='flex-shrink-0 size-5' />,
        color: "from-blue-400 to-blue-600",
        url: "/account/preferences",
      },
      {
        name: "Watchlists",
        icon: <Heart weight='fill' className='flex-shrink-0 size-5' />,
        color: "from-red-400 to-red-600",
        info: undefined,
        url: "/account/watchlist",
      },
      {
        name: "Bookmarks",
        icon: (
          <BookmarksSimple weight='fill' className='flex-shrink-0 size-5' />
        ),
        color: "from-red-400 to-red-600",
        info: undefined,
        url: "/account/bookmarks",
      },
      {
        name: "Reports History",
        icon: (
          <BookmarksSimple weight='fill' className='flex-shrink-0 size-5' />
        ),
        color: "from-purple-400 to-purple-600",
        url: "/account/report-history",
      },
    ],
  },
  {
    category: "Payments",
    children: [
      {
        name: "Payment Methods",
        icon: <Gear weight='fill' className='flex-shrink-0 size-5' />,
        color: "from-orange-400 to-orange-600",
        url: "/account/payment",
      },
      {
        name: "Billing History",
        icon: (
          <BookmarksSimple weight='fill' className='flex-shrink-0 size-5' />
        ),
        color: "from-red-400 to-red-600",
        url: "/account/billing",
      },
    ],
  },
];
